<template>
  <v-dialog
    v-model="show"
    persistent
    max-width="600px"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">
          Please Complete Provision Information
        </span>
      </v-card-title>
      <v-card-subtitle>
        <span class="first--text">
          you must complete any required information before proceeding.
        </span>
      </v-card-subtitle>
      <v-card-text>
        <v-form
          ref="provision_form"
          v-model="valid"
          lazy-validation
        >
          <!-- eslint-disable -->
          <v-row v-if="provision === 'government'">
            <v-col cols="12">
              The undersigned claims exemption from the tax imposed on all local telephone services: toll telephone or radio telephone message or conversations billed or to be billed the undersigned. The undersigned certifies that such exemption is allowable by law for the reason that such services are being and will be furnished to and charges will be paid from funds of (check one):
            </v-col>

            <v-col cols="12">
              <v-radio-group
              v-model="provisionForm.government.fedtax_government_payer.value"
              :rules="provisionForm.government.fedtax_government_payer.rules"
              required
            >
                <v-radio value="united_states">
                  <template v-slot:label>
                    <small>The United States (Section 4293), a state [must perform a traditional government function or be sufficiently controlled by state or local government] or political subdivision thereof (Section 4253).</small>
                  </template>
                </v-radio>

                <v-radio value="public_international_organization">
                  <template v-slot:label>
                    <small>A Public International Organization (Section 4253, 7701 (a)(18)).</small>
                  </template>
                </v-radio>

                <v-radio value="act_of_congress">
                  <template v-slot:label>
                    <small>An organization created by Act of Congress which is tax exempt</small>
                  </template>
                </v-radio>

                <v-row v-if="provisionForm.government.fedtax_government_payer.value === 'act_of_congress'" class="pa-6">
                  <v-col cols="12">
                    <div class="subtitle-2">Exempting statute under which claim is made</div>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="provisionForm.government.act_of_congress_helpblock.value"
                      :rules="provisionForm.government.act_of_congress_helpblock.rules"
                      required
                      label="Exempting statute"
                    ></v-text-field>
                  </v-col>
                </v-row>

                <v-radio value="government_body">
                  <template v-slot:label>
                    <small>United Delegations and Delegates (Public Law 357-80th Congress, Section 15) Paid from the funds of</small>
                  </template>
                </v-radio>

                <v-row v-if="provisionForm.government.fedtax_government_payer.value === 'government_body'" class="pa-6">
                  <v-col cols="12">
                    <div class="subtitle-2">Exempting statute under which claim is made</div>
                  </v-col>

                  <v-col cols="12">
                    <v-text-field
                      v-model="provisionForm.government.fedtax_exempting_body.value"
                      :rules="provisionForm.government.fedtax_exempting_body.rules"
                      required
                      label="Name of Exempt Organization"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-radio-group>
            </v-col>
            <v-col cols="12">
              <small>*(Must be recognizable as government agency, i.e. , U.S. Dept. of Agriculture, State of Nebraska, City of Lincoln, Name of Foreign Government, etc.)</small>
            </v-col>
          </v-row>

          <v-row v-if="provision === 'nonprofit_educational'">
            <v-col cols="12">
              The undersigned certifies that the communication services or facilities furnished or to be furnished to the organization will be paid fromfunds of the organization and are for the EXCLUSIVE use of the organizations in the educational activities which qualify it for exemption from tax underSection 4253(j) of the Internal Revenue Code. <br><br>
              The exempt organization normally maintains a regular faculty and curriculum and normally has a regularly enrolled body of pupils or students in attendance at the place where its educational activities are regularly carried on.<br><br>

              The organization claiming exemption under this certificate has received a determination letter (or a ruling) from the Internal Revenue Service holding the organization to be exempt from income tax as an organization described in Section 501 (c )(3) of the Internal Revenue Code (or had received such determination letter (or ruling) under the corresponding provisions for prior revenue laws). The date of such determination letter (or ruling) is

              <v-row>
                <v-col>
                  <VDateField
                    label="Determination Ruling Date"
                    persistent-hint
                    v-model="provisionForm.nonprofit_educational.fedtax_irs_education_date.value"
                  />
                </v-col>
              </v-row>

              and such determination letter (or ruling) has not been withdrawn or revoked.<br><br>

              Paid from the funds of 
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="provisionForm.nonprofit_educational.fedtax_nonprofit_educational_organization.value"
                    :rules="provisionForm.nonprofit_educational.fedtax_nonprofit_educational_organization.rules"
                    required
                    label="Name of nonprofit educational organization"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row v-if="provision === 'religious_school'">
            <v-col cols="12">
              The undersigned certifies that the communications services or facilities furnished or to be furnished to the institution will be paid from the funds of the institution and are for the EXCLUSIVE use of the school.<br><br>

              The school operates as an activity of the church, parish, or other religious body, normally maintains a regular faculty and curriculum and normally has a regularly enrolled body of pupils or students in attendance at the place where its educational activities are regularly carried on.<br><br>

              Paid from the funds of 
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="provisionForm.religious_school.fedtax_religious_body.value"
                    :rules="provisionForm.religious_school.fedtax_religious_body.rules"
                    required
                    label="Name of church, parish or other religious body"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-col>
          </v-row>

          <v-row v-if="provision === 'nonprofit_hospital'">
            <v-col cols="12">
              The undersigned claims exemption under Section 4253(h) of the Internal Revenue Code from the tax imposed by Section 4251 of thecodeon all local telephone service, toll telephone service or radiotelephone messages or conversations, billed or to be billed for the undersigned.<br><br>

              The undersigned has received a determination letter ( or a ruling) from the Internal Revenue Service holding the organization to be exempt from income tax under Section 501 (a) of the Internal Revenue Code (or has received such determination letter (or ruling) under the corresponding provisions for prior revenue laws). The date of such determination letter (or ruling) is <br><br>

              <v-row>
                <v-col>
                  <VDateField
                    label="Determination Ruling Date"
                    persistent-hint
                    v-model="provisionForm.nonprofit_hospital.fedtax_irs_hospital_date.value"
                  />
                </v-col>
              </v-row>

              and such determination letter (or ruling) has not been withdrawn or revoked.<br><br>
            </v-col>
          </v-row>

          <v-row v-if="provision === 'telecom'">
            <v-col cols="12">
              The undersigned claims exemption UNDER Section 4253(f) of the Internal Revenue Code from the tax imposed on Wide Area TelephoneService (WATS) or Optional Calling Plan (OCP). In making this claim, the undersigned certifies that such service has been andwill beused exclusively in the conduct of its business as a (check one):
            </v-col>

            <v-col cols="12">
              <v-radio-group
                v-model="provisionForm.telecom.fedtax_telecom_type.value"
                :rules="provisionForm.telecom.fedtax_telecom_type.rules"
                required
              >
                <v-radio value="common_carrier">
                  <template v-slot:label>
                    <small>Common Carrier</small>
                  </template>
                </v-radio>

                <v-radio value="telephone_company">
                  <template v-slot:label>
                    <small>Telephone Company</small>
                  </template>
                </v-radio>

                <v-radio value="telegraph_company">
                  <template v-slot:label>
                    <small>Telegraph Company</small>
                  </template>
                </v-radio>

                <v-radio value="radio_television">
                  <template v-slot:label>
                    <small>Radio or Television Broadcasting Station or Network</small>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-col>
          </v-row>

          <v-row v-if="provision === 'taxable_component'">
            <v-col cols="12">
              The undersigned certifies that <br><br>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="provisionForm.taxable_component.fedtax_taxable_service.value"
                    :rules="provisionForm.taxable_component.fedtax_taxable_service.rules"
                    required
                    label="Description of service or facility"
                  ></v-text-field>
                </v-col>
              </v-row>

              The undersigned certifies that such exemption is allowable by law under the terms of a treaty between the United States and the country which the undersigned represents, and that he or she is not engaged in professional business, trade, manufacture, or commerceand is not acitizen of the United States.
            </v-col>
          </v-row>

          <v-row v-if="provision === 'news_service'">
            The undersigned certifies that the communication services furnished or to be furnishedare used or will be used in the collection or dissemination of news for the public press,or a news ticker service furnishing a general news service similar to that of the public press,or radio broadcasting {Section 4253(b)].
          </v-row>
          
          <v-row v-if="provision === 'foreign'">
            <v-col cols="12">
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="provisionForm.foreign.fedtax_foreign_government.value"
                    :rules="provisionForm.foreign.fedtax_foreign_government.rules"
                    required
                    label="Name of non-USA government"
                  ></v-text-field>
                </v-col>
              </v-row>

              The undersigned certifies that such exemption is allowable by law under the terms of a treaty between the United States and the country which the undersigned represents, and that he or she is not engaged in professional business, trade, manufacture, or commerceand is not acitizen of the United States.
            </v-col>
          </v-row>

          <v-row v-if="provision === 'not_exempt'">
            <v-col cols="12">
              Please enter the date from which you are/were no longer exempt from Federal Excise Taxes<br><br>

              <v-row>
                <v-col>
                  <VDateField
                    label="Fed Tax Exempt End Date"
                    persistent-hint
                    v-model="provisionForm.not_exempt.fedtax_not_exempt_date.value"
                  />
                </v-col>
              </v-row>

              and such determination letter (or ruling) has not been withdrawn or revoked.<br><br>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="red darken-1"
          text
          @click="() => cancelModal()"
        >
          Close
        </v-btn>
        <v-btn
          color="third darken-1"
          text
          @click="() => save()"
        >
          {{ (provision === 'news_service') ? 'OK' : 'Save' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import VDateField from '@/components/formfields/VDateField.vue';

export default {
  name: 'ProvisionForm',
  props: {
    show: { type: Boolean, required: false },
    provision: { type: String, required: false },
  },
  data() {
    return {
      valid: true,
      provisionForm: {
        government: {
          fedtax_government_payer: {
            value: null,
            rules: [
              (v) => !!v || 'Option is required',
            ],
          },
          act_of_congress_helpblock: {
            value: null,
            rules: [
              (v) => !!v || 'Name is required',
              (v) => (v && v.length >= 2) || 'Name must be a minimum of 2 characters',
            ],
          },
          fedtax_exempting_body: {
            value: null,
            rules: [
              (v) => !!v || 'Name is required',
              (v) => (v && v.length >= 2) || 'Name must be a minimum of 2 characters',
            ],
          },
        },

        nonprofit_educational: {
          fedtax_irs_education_date: {
            value: null,
            rules: [
              (v) => !!v || 'Name is required',
              (v) => (v && v.length >= 2) || 'Name must be a minimum of 2 characters',
            ],
          },
          fedtax_nonprofit_educational_organization: {
            value: null,
            rules: [
              (v) => !!v || 'Name is required',
              (v) => (v && v.length >= 2) || 'Name must be a minimum of 2 characters',
            ],
          },
        },

        religious_school: {
          fedtax_religious_body: {
            value: null,
            rules: [
              (v) => !!v || 'Name is required',
              (v) => (v && v.length >= 2) || 'Name must be a minimum of 2 characters',
            ],
          },
        },

        nonprofit_hospital: {
          fedtax_irs_hospital_date: {
            value: null,
            rules: [
              (v) => !!v || 'Name is required',
              (v) => (v && v.length >= 2) || 'Name must be a minimum of 2 characters',
            ],
          },
        },

        telecom: {
          fedtax_telecom_type: {
            value: null,
            rules: [
              (v) => !!v || 'Option is required',
            ],
          },
        },

        taxable_component: {
          fedtax_taxable_service: {
            value: null,
            rules: [
              (v) => !!v || 'Name is required',
              (v) => (v && v.length >= 2) || 'Name must be a minimum of 2 characters',
            ],
          },
        },

        news_service: {},

        foreign: {
          fedtax_foreign_government: {
            value: null,
            rules: [
              (v) => !!v || 'Name is required',
              (v) => (v && v.length >= 2) || 'Name must be a minimum of 2 characters',
            ],
          },
        },

        not_exempt: {
          fedtax_not_exempt_date: {
            value: null,
            rules: [
              (v) => !!v || 'Name is required',
              (v) => (v && v.length >= 2) || 'Name must be a minimum of 2 characters',
            ],
          },
        },
      },
    };
  },
  methods: {
    cancelModal() {
      this.$emit('closeModal', { cancel: true });
      this.reset();
    },
    save() {
      if (this.$refs.provision_form.validate()) {
        this.$emit('setProvision', this.provisionForm);
      }
    },
    reset() {
      this.$refs.provision_form.reset();
    },
  },
  components: {
    VDateField,
  },
};
</script>
